import db from "@/plugins/dexie";
import { USER_STORAGE  } from '@/constants/STORAGE'
import apirecebimentoweb from '@/services/api-recebimentoweb';
// import geraDataV2 from "../geraDataV2";
import moment from "moment-timezone";
import store from "@/store";
import geraData from "../geradata";

function getSessionStorage(key, defaultValue) {
  return sessionStorage.getItem(key) ?? defaultValue;
}

export default async function $_enviaOrdemItem() {
  const token = JSON.parse(sessionStorage.getItem('auth:token'));
  const unidades = await db.ordemcarregamentounidade.toArray();
  let itens = await db.ordemcarregamentoitem.toArray();
  itens = await itens.filter(o => o.ocidatanuvem === null);
  const idusuario = await getSessionStorage(USER_STORAGE.useidusuario);
  await Promise.all(itens.map(async (item) => {
          // Espera só unidades ainda não criadas na nuvem; item sem unidade também sobe.
          const unidadesSemNuvem = unidades.filter((u) => !u.ocuexclusao && (u.ocuidordemcarregamentoitem === item.ociidordemcarregamentoitem) && (!u.ocuidnuvem || u.ocuidnuvem === 'null'))
          console.log('unidades sem nuvem', unidadesSemNuvem);
          const unidadesEnviadas = unidadesSemNuvem.length === 0
          if (unidadesEnviadas && (item.ociidnuvem) && (item.ociidnuvem !== 'null')) {
              console.log('put - ', item);
              const payload = {
                  ocidataalteracao: geraData(),
                  ociidcliente: item?.ociidcliente,
                  ocidatafinalizado: item?.ocidatafinalizado,
                  ociidusuario: idusuario,
                  id: item.ociidnuvem,
              }
              await apirecebimentoweb.put(`/ordemcarregamentoitem/${item.ociidnuvem}`, payload, {
                  headers: {
                      Authorization: `Bearer ${token.token}`
                  }
              }).then(async (res) => {
                  console.log('alteracao vindo ordemitem',moment.utc(res.data.ocidataalteracao).format('YYYY-MM-DD HH:mm:ss.SSS'));
                  const alteracao = (moment.utc(res.data.ocidataalteracao).format('YYYY-MM-DD HH:mm:ss.SSS'))
                  await db.ordemcarregamentoitem.update(item.id, {
                      ocidataalteracao: alteracao,
                      ocidatanuvem: alteracao,
                  });
                  store.dispatch('cache/atualizaData', { data: alteracao, tabela: 'ordemcarregamentoitem' });
              }).catch((err) => {
                  console.log(err);
              });
          }
  }));
}
